import { memo } from 'react'
import { twMerge } from 'tailwind-merge'
import { Badge } from '@highlight/ui'

interface UnreadBadgeProps {
  count: number
  className?: string
}

export const UnreadBadge = memo(function UnreadBadge({ count, className }: UnreadBadgeProps) {
  if (count <= 0) return null

  return (
    <Badge variant="solid" tone="danger" size="xs" className={twMerge('ml-2', className)}>
      {count}
    </Badge>
  )
})
